import { JOGOS_COPA_2026 } from '../data/copaMundo2026';
import type { PlacaresMap } from './copaCalculo';

/**
 * Codifica nome + 72 palpites em uma string curta segura para URL.
 * Estratégia: monta um JSON enxuto, converte para UTF-8 e aplica base64 "url-safe".
 */
export function encodePalpitesUrl(
  nome: string,
  setor: string,
  palpites: PlacaresMap
): string {
  const partes = JOGOS_COPA_2026.map((j) => {
    const p = palpites[j.id];
    if (!p) return '';
    const m = Number(p.mandante);
    const v = Number(p.visitante);
    if (!Number.isFinite(m) || !Number.isFinite(v) || m < 0 || v < 0) return '';
    return `${m}-${v}`;
  });
  const payload = JSON.stringify({
    n: String(nome || '').trim(),
    s: String(setor || '').trim(),
    p: partes,
  });
  try {
    const utf8 = unescape(encodeURIComponent(payload));
    const b64 = btoa(utf8);
    return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  } catch {
    return '';
  }
}

/**
 * Decodifica o parâmetro `dados` da URL gerada pelo formulário público.
 * Retorna null se a string for inválida.
 */
export function decodePalpitesUrl(
  s: string
): { nome: string; setor: string; palpites: PlacaresMap } | null {
  if (!s) return null;
  try {
    const limpo = s.replace(/-/g, '+').replace(/_/g, '/');
    const pad = '='.repeat((4 - (limpo.length % 4)) % 4);
    const utf8 = atob(limpo + pad);
    const raw = decodeURIComponent(escape(utf8));
    const obj = JSON.parse(raw) as { n?: string; s?: string; p?: string[] };
    if (!obj || typeof obj.n !== 'string' || !Array.isArray(obj.p)) return null;
    const palpites: PlacaresMap = {};
    JOGOS_COPA_2026.forEach((j, i) => {
      const entry = obj.p![i] || '';
      if (!entry) return;
      const [ms, vs] = entry.split('-');
      const m = parseInt(ms, 10);
      const v = parseInt(vs, 10);
      if (Number.isFinite(m) && Number.isFinite(v) && m >= 0 && v >= 0) {
        palpites[j.id] = { mandante: m, visitante: v };
      }
    });
    return {
      nome: obj.n.trim(),
      setor: typeof obj.s === 'string' ? obj.s.trim() : '',
      palpites,
    };
  } catch {
    return null;
  }
}
